import "./EditableEntries.css";
import EditableEntry from "./EditableEntry";
import {useId} from "react";

const invalidClass = "inputter-invalid";

type EditableCardEntryInputProps = {
    baseValue: string | number | boolean | null | undefined;
    type?: React.HTMLInputTypeAttribute;
    onEdit?: (value: string | boolean | undefined, validity: ValidityState) => void;
    isEditing?: boolean;
    displayLabel?: string;
    displayValue?: string | number | boolean | null | undefined;
    displayUnsafe?: string | number | boolean | null | undefined;
    max?: string | number;
    min?: string | number;
    step?: string | number;
    required?: boolean;
    requestSubmission?: () => void;
    explanation?: string | Element;
    hyperlinkDisplay?: boolean;
    placeholder?: string;
};

const EditableCardEntryInput = ({
    baseValue,
    type = "text",
    onEdit,
    isEditing = false,
    displayLabel,
    displayValue = baseValue,
    displayUnsafe,
    max,
    min,
    step,
    required = false,
    requestSubmission = () => {},
    explanation,
    placeholder,
}: EditableCardEntryInputProps) => {
    const idRoot = useId();

    return <EditableEntry
        label={displayLabel}
        isEditing={isEditing}
        id={idRoot}
        explanation={explanation}
        viewingChildren={displayValue ? (<span id={idRoot}>{displayValue}</span>) : <i>None</i>}
        editingChildren={
            <input
                max={max}
                min={min}
                step={step}
                id={idRoot}
                type={type}
                // @ts-ignore
                value={baseValue === null ? '' : baseValue}
                onChange={(e) => {
                    const dis = e.target as HTMLInputElement;

                    const validity = dis.validity;

                    if (required && validity.valueMissing) {
                        dis.classList.add(invalidClass);
                    } else if (!validity.valid) {
                        dis.classList.add(invalidClass);
                    } else {
                        dis.classList.remove(invalidClass);
                    }

                    if (onEdit) {
                        if (type === "checkbox") {
                            onEdit(e.target.checked, validity);
                        } else {
                            onEdit(e.target.value, validity);
                        }
                    }
                }}
                onKeyDown={(e) => e.key === "Enter" ? requestSubmission() : false}
                placeholder={placeholder}
            />
        }
    />;
};

export default EditableCardEntryInput;
